// extracted by mini-css-extract-plugin
export default {"modal-style":"ConfirmModal_modal-style__k9Ci3"};